export default __webpack_public_path__ + "static/media/profile-img.b2ab572a.png";